<flx-modal
  [dismissible]="true"
  (dismiss)="closeModal()"
  class="flx-ds large h-full w-full rounded-b-none"
>
  <div
    class="flex items-center justify-center w-full h-12 text-lg font-bold border-b border-neutral-100 truncate"
    flxModalHeaderTitle
    data-testId="versioning-view-title"
  >
    Changes for {{ resourceName }}
  </div>

  <flx-resources-grid
    [items]="resourceHistory() || []"
    [tableDef]="tableColumnsDef()"
    [uniqueKeys]="['commitMessage']"
    [rowClickEnabled]="false"
    [loading]="!resourceHistory()"
    class="h-full"
    emptyMsg="No history yet"
    emptyMsgDescription="Every version that changed this resource is listed here."
    emptyMsgIcon="ph ph-hourglass"
  />
</flx-modal>

<ng-template
  [flxShowModal]="comparedResource.value()"
  (escapeKeyPressed)="toggleResourceCompare()"
  panelClass="version-compare-modal"
>
  <flx-version-compare-modal (closeModal)="toggleResourceCompare()">
    <flx-compare-versioning-info
      [compareWithVersion]="compareWithVersion()"
      [selectedAppVersion]="selectedAppVersion()"
    />
  </flx-version-compare-modal>
</ng-template>
